"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for pushwoosh.rpc_v2.accounts
 * @enhanceable
 * @public
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsServiceClient = void 0;
// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.19.1
// source: pushwoosh/accounts/accounts.proto
/* eslint-disable */
// @ts-nocheck
const grpcWeb = __importStar(require("grpc-web"));
const pushwoosh_accounts_accounts_pb = __importStar(require("../../pushwoosh/accounts/accounts_pb"));
class AccountsServiceClient {
    constructor(hostname, credentials, options) {
        this.methodDescriptorGetEmailStatisticCount = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetEmailStatisticCount', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetEmailStatisticCountRequest, pushwoosh_accounts_accounts_pb.GetEmailStatisticCountResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetEmailStatisticCountResponse.deserializeBinary);
        this.methodDescriptorGetActiveDevicesCount = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetActiveDevicesCount', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetActiveDevicesCountRequest, pushwoosh_accounts_accounts_pb.GetActiveDevicesCountResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetActiveDevicesCountResponse.deserializeBinary);
        this.methodDescriptorGetSubscribersCount = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetSubscribersCount', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetSubscribersCountRequest, pushwoosh_accounts_accounts_pb.GetSubscribersCountResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetSubscribersCountResponse.deserializeBinary);
        this.methodDescriptorGetActiveUsersCount = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetActiveUsersCount', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetActiveUsersCountRequest, pushwoosh_accounts_accounts_pb.GetActiveUsersCountResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetActiveUsersCountResponse.deserializeBinary);
        this.methodDescriptorSetDebugMode = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/SetDebugMode', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.SetDebugModeRequest, pushwoosh_accounts_accounts_pb.SetDebugModeResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.SetDebugModeResponse.deserializeBinary);
        this.methodDescriptorGetOnboardingInfo = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetOnboardingInfo', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetOnboardingInfoRequest, pushwoosh_accounts_accounts_pb.GetOnboardingInfoResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetOnboardingInfoResponse.deserializeBinary);
        this.methodDescriptorUpdateOnboardingInfo = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/UpdateOnboardingInfo', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.UpdateOnboardingInfoRequest, pushwoosh_accounts_accounts_pb.UpdateOnboardingInfoResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.UpdateOnboardingInfoResponse.deserializeBinary);
        this.methodDescriptorGetTotalEmailSubscribersCount = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetTotalEmailSubscribersCount', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetTotalEmailSubscribersCountRequest, pushwoosh_accounts_accounts_pb.GetTotalEmailSubscribersCountResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetTotalEmailSubscribersCountResponse.deserializeBinary);
        this.methodDescriptorGetBillingAddress = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetBillingAddress', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetBillingAddressRequest, pushwoosh_accounts_accounts_pb.GetBillingAddressResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetBillingAddressResponse.deserializeBinary);
        this.methodDescriptorUpdateBillingAddress = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/UpdateBillingAddress', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.UpdateBillingAddressRequest, pushwoosh_accounts_accounts_pb.UpdateBillingAddressResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.UpdateBillingAddressResponse.deserializeBinary);
        this.methodDescriptorGetAccount = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetAccount', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetAccountRequest, pushwoosh_accounts_accounts_pb.GetAccountResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetAccountResponse.deserializeBinary);
        this.methodDescriptorUpdateAccount = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/UpdateAccount', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.UpdateAccountRequest, pushwoosh_accounts_accounts_pb.UpdateAccountResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.UpdateAccountResponse.deserializeBinary);
        this.methodDescriptorGetBillingInfo = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/GetBillingInfo', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.GetBillingInfoRequest, pushwoosh_accounts_accounts_pb.GetBillingInfoResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.GetBillingInfoResponse.deserializeBinary);
        this.methodDescriptorUpdateBillingInfo = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.accounts.AccountsService/UpdateBillingInfo', grpcWeb.MethodType.UNARY, pushwoosh_accounts_accounts_pb.UpdateBillingInfoRequest, pushwoosh_accounts_accounts_pb.UpdateBillingInfoResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_accounts_accounts_pb.UpdateBillingInfoResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname.replace(/\/+$/, '');
        this.credentials_ = credentials;
        this.options_ = options;
    }
    getEmailStatisticCount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetEmailStatisticCount', request, metadata || {}, this.methodDescriptorGetEmailStatisticCount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetEmailStatisticCount', request, metadata || {}, this.methodDescriptorGetEmailStatisticCount);
    }
    getActiveDevicesCount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetActiveDevicesCount', request, metadata || {}, this.methodDescriptorGetActiveDevicesCount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetActiveDevicesCount', request, metadata || {}, this.methodDescriptorGetActiveDevicesCount);
    }
    getSubscribersCount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetSubscribersCount', request, metadata || {}, this.methodDescriptorGetSubscribersCount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetSubscribersCount', request, metadata || {}, this.methodDescriptorGetSubscribersCount);
    }
    getActiveUsersCount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetActiveUsersCount', request, metadata || {}, this.methodDescriptorGetActiveUsersCount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetActiveUsersCount', request, metadata || {}, this.methodDescriptorGetActiveUsersCount);
    }
    setDebugMode(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/SetDebugMode', request, metadata || {}, this.methodDescriptorSetDebugMode, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/SetDebugMode', request, metadata || {}, this.methodDescriptorSetDebugMode);
    }
    getOnboardingInfo(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetOnboardingInfo', request, metadata || {}, this.methodDescriptorGetOnboardingInfo, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetOnboardingInfo', request, metadata || {}, this.methodDescriptorGetOnboardingInfo);
    }
    updateOnboardingInfo(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/UpdateOnboardingInfo', request, metadata || {}, this.methodDescriptorUpdateOnboardingInfo, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/UpdateOnboardingInfo', request, metadata || {}, this.methodDescriptorUpdateOnboardingInfo);
    }
    getTotalEmailSubscribersCount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetTotalEmailSubscribersCount', request, metadata || {}, this.methodDescriptorGetTotalEmailSubscribersCount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetTotalEmailSubscribersCount', request, metadata || {}, this.methodDescriptorGetTotalEmailSubscribersCount);
    }
    getBillingAddress(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetBillingAddress', request, metadata || {}, this.methodDescriptorGetBillingAddress, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetBillingAddress', request, metadata || {}, this.methodDescriptorGetBillingAddress);
    }
    updateBillingAddress(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/UpdateBillingAddress', request, metadata || {}, this.methodDescriptorUpdateBillingAddress, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/UpdateBillingAddress', request, metadata || {}, this.methodDescriptorUpdateBillingAddress);
    }
    getAccount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetAccount', request, metadata || {}, this.methodDescriptorGetAccount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetAccount', request, metadata || {}, this.methodDescriptorGetAccount);
    }
    updateAccount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/UpdateAccount', request, metadata || {}, this.methodDescriptorUpdateAccount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/UpdateAccount', request, metadata || {}, this.methodDescriptorUpdateAccount);
    }
    getBillingInfo(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/GetBillingInfo', request, metadata || {}, this.methodDescriptorGetBillingInfo, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/GetBillingInfo', request, metadata || {}, this.methodDescriptorGetBillingInfo);
    }
    updateBillingInfo(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.accounts.AccountsService/UpdateBillingInfo', request, metadata || {}, this.methodDescriptorUpdateBillingInfo, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.accounts.AccountsService/UpdateBillingInfo', request, metadata || {}, this.methodDescriptorUpdateBillingInfo);
    }
}
exports.AccountsServiceClient = AccountsServiceClient;
